/*eslint-disable no-unused-vars*/
import React, { Component } from 'react';
import AnimationPlayer from './components/AnimationPlayer';
/*eslint-enable no-unused-vars*/
import './Ai2html.css';
import './Artboards.css';
import kriegDerBilder from './images/krieg-der-bilder.png';
import title from './images/Title.png';
import caption from './images/Caption.png';
import text from './images/Text.png';
import slide1 from './images/slide-1.jpg';
import slide2 from './images/slide-2.jpg';
import slide3 from './images/slide-3.jpg';
import slide4 from './images/slide-4.jpg';
import slide5 from './images/slide-5.jpg';


export class Ai2htmlAnimation extends Component {
  render() {
    return (
      <AnimationPlayer>
        <div className="krieg-der-bilder">
          <img className="background-image" src={kriegDerBilder} alt="" />
          <img src={title} className="pos-text title" alt="" />
          <img src={caption} className="pos-text confession" alt="" />
          <img src={text} className="pos-text text" alt="" />
        </div>
      </AnimationPlayer>
    );
  }
}

export class ArtboardsAnimation extends Component {
  render() {
    return (
      <AnimationPlayer>
        <div className="artboard-list">
        <img id="artboard-1" src={slide1} alt="" />
        <img id="artboard-2" src={slide2} alt="" />
        <img id="artboard-3" src={slide3} alt="" />
        <img id="artboard-4" src={slide4} alt="" />
        <img id="artboard-5" src={slide5} alt="" />
      </div>  
      </AnimationPlayer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.js